// ABOUTME: Shareable Links page, shown in place of Program Access to admins who can
// ABOUTME: share collection courses (DVLP-7041). Loads its own lightweight payload.
import { assertNever } from '@kofno/piper';
import { observer } from 'mobx-react';
import { useMemo } from 'react';
import Loader from '../../../../Loader';
import LoadError from '../../LoadError';
import Body from './Body';
import ShareableLinksReactions from './Reactions';
import ShareableLinksStore from './Store';

interface Props {
  id: string;
}

interface ContentProps {
  store: ShareableLinksStore;
}

const Content = observer(function Content({ store }: ContentProps) {
  switch (store.state.kind) {
    case 'loading':
      return <Loader />;
    case 'failed':
      return <LoadError />;
    case 'ready':
      return <Body pageStore={store} state={store.state} />;
    default:
      return assertNever(store.state);
  }
});

function ShareableLinks({ id }: Props) {
  const store = useMemo(() => new ShareableLinksStore(id), [id]);
  return (
    <>
      <Content store={store} />
      <ShareableLinksReactions store={store} fireImmediately />
    </>
  );
}

export default observer(ShareableLinks);
